import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/app/app/layouts/admin.vue").then(m => m.default || m)),
  blank: defineAsyncComponent(() => import("/app/app/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/app/layouts/default.vue").then(m => m.default || m)),
  dora: defineAsyncComponent(() => import("/app/app/layouts/dora.vue").then(m => m.default || m))
}